module.exports = {
  xxs: 320,
  xs: 420,
  sm: 640,
  md: 768,
  lg: 1440,
  xl: 1920,
  xxl: 2560
}
